import React from "react";
import { Navigate, Outlet, useRoutes } from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Layout from "./components/Layout";
import PropertyDetailsPage from "./pages/PropertyDetails";
import { config } from "./constants";
import { useSelector } from "react-redux";
import ProductCatalogPage from "./pages/ProductCatalog/ProductCatalogPage";
import ImageSearchPage from "./pages/ImageSearch/ImageSearchPage";

/** Amplify Configuration */
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import { amplifyConfig } from "./config/config";
import PropertySheetPage from "./pages/PropertySheet/PropertySheetPage";
import SheetDetailPage from "./pages/PropertySheet/Detail";
import PropertyUpdatePage from "./pages/PropertyUpdate/PropertyUpdatePage";
import PropertyLandingPage from "./pages/PropertyLandingPage";
import PropertyRoomDetailsPage from "./pages/PropertyLandingPage/PropertyRoomDetailsPage";
import CheckoutConfirmationPage from "./pages/CheckoutConfirmation";
import InvoicePage from "./pages/InvoicePage";
import UserManagementPage from "./pages/UserManagement";
import ProtectedRoute from "./components/ProtectedRoute";
import useUserStatusMonitor from "./hooks/useUserStatusMonitor";
Amplify.configure(amplifyConfig);

const App = () => {
  const isLogged = useSelector(state => state.user.isLogged);
  // Log current environment for debugging
  // eslint-disable-next-line no-console
  console.log('REACT_APP_ENV:', process.env.REACT_APP_ENV);
  
  // Monitor user status and auto-logout if deactivated/deleted
  useUserStatusMonitor();
  const router = useRoutes([
    {
      path: config.PATH_URI.HOME,
      element: isLogged ? <Layout /> : <Navigate to={config.PATH_URI.LOGIN} />,
      children: [
        {
          path: config.PATH_URI.HOME,
          element: <Home />,
        },
        {
          path: config.PATH_URI.PROPERTY_CREATE,
          element: <PropertyDetailsPage />,
        },
        {
          path: config.PATH_URI.PROPERTY_UPDATE,
          element: <PropertyUpdatePage />,
        },
        {
          path: config.PATH_URI.PRODUCT_CATALOG,
          element: <ProductCatalogPage />,
        },
        {
          path: config.PATH_URI.PROPERTY_SHEET.MAIN,
          element: <Outlet />,
          children: [
            {
              path: config.PATH_URI.PROPERTY_SHEET.MAIN,
              element: <PropertySheetPage />,
            },
            {
              path: config.PATH_URI.PROPERTY_SHEET.DETAIL,
              element: <SheetDetailPage />,
            },
          ],
        },
      ],
    },
    {
      path: config.PATH_URI.IMAGE_SEARCH,
      element: isLogged ? <Layout /> : <Navigate to={config.PATH_URI.LOGIN} />,
      children: [
        {
          path: config.PATH_URI.IMAGE_SEARCH,
          element: <ImageSearchPage />,
        },
      ],
    },
    {
      path: config.PATH_URI.USER_MANAGEMENT,
      element: isLogged ? <Layout /> : <Navigate to={config.PATH_URI.LOGIN} />,
      children: [
        {
          path: config.PATH_URI.USER_MANAGEMENT,
          element: (
            <ProtectedRoute requiredRole="admin">
              <UserManagementPage />
            </ProtectedRoute>
          ),
        },
      ],
    },
    {
      path: config.PATH_URI.LOGIN,
      element: isLogged ? <Navigate to={config.PATH_URI.HOME} /> : <Login />,
    },
    {
      path: config.PATH_URI.PROPERTY_LANDING_PAGE,
      element: <PropertyLandingPage />,
    },
    {
      path: config.PATH_URI.PROPERTY_ROOM_DETAILS,
      element: <PropertyRoomDetailsPage />,
    },
    {
      path: config.PATH_URI.CHECKOUT_CONFIRMATION,
      element: <CheckoutConfirmationPage />,
    },
    {
      path: config.PATH_URI.INVOICE,
      element: <InvoicePage />,
    },
  ]);
  return router;
};

export default App;
